import { useTranslation } from '@/context/TranslationContext';
import styles from './Trust.module.scss';

export default function Trust() {
    const { t } = useTranslation();

    const benefits = [
        {
            title: 'TRUST.BENEFITS.B1.TITLE',
            description: 'TRUST.BENEFITS.B1.DESC',
            icon: 'bx bx-rocket'
        },
        {
            title: 'TRUST.BENEFITS.B2.TITLE',
            description: 'TRUST.BENEFITS.B2.DESC',
            icon: 'bx bx-money'
        },
        {
            title: 'TRUST.BENEFITS.B3.TITLE',
            description: 'TRUST.BENEFITS.B3.DESC',
            icon: 'bx bx-trending-up'
        }
    ];

    const promises = [
        {
            title: 'TRUST.PROMISE.P1.TITLE',
            description: 'TRUST.PROMISE.P1.DESC',
            icon: 'bx bx-check-circle'
        },
        {
            title: 'TRUST.PROMISE.P2.TITLE',
            description: 'TRUST.PROMISE.P2.DESC',
            icon: 'bx bx-chat'
        },
        {
            title: 'TRUST.PROMISE.P3.TITLE',
            description: 'TRUST.PROMISE.P3.DESC',
            icon: 'bx bx-time'
        }
    ];

    const processSteps = [
        {
            title: 'TRUST.PROCESS.S1.TITLE',
            description: 'TRUST.PROCESS.S1.DESC',
            icon: 'bx bx-search-alt'
        },
        {
            title: 'TRUST.PROCESS.S2.TITLE',
            description: 'TRUST.PROCESS.S2.DESC',
            icon: 'bx bx-list-check'
        },
        {
            title: 'TRUST.PROCESS.S3.TITLE',
            description: 'TRUST.PROCESS.S3.DESC',
            icon: 'bx bx-code-alt'
        },
        {
            title: 'TRUST.PROCESS.S4.TITLE',
            description: 'TRUST.PROCESS.S4.DESC',
            icon: 'bx bx-globe'
        }
    ];

    return (
        <section id="trust" className={styles.trust}>
            <div className={styles.container}>
                <div className={styles.header} data-aos="fade-up">
                    <h2 className={styles.sectionTitle}>{t('TRUST.TITLE')}</h2>
                    <p className={styles.subtitle}>{t('TRUST.SUBTITLE')}</p>
                </div>

                <div className={styles.content}>
                    {/* Benefits Section */}
                    <div className={styles.section} data-aos="fade-up">
                        <h3 className={styles.sectionHeading}>{t('TRUST.BENEFITS.TITLE')}</h3>
                        <div className={styles.grid}>
                            {benefits.map((benefit, index) => (
                                <div key={index} className={styles.card} data-aos="fade-up" data-aos-delay={index * 100}>
                                    <div className={styles.iconWrapper}>
                                        <i className={benefit.icon}></i>
                                    </div>
                                    <h4 className={styles.cardTitle}>{t(benefit.title)}</h4>
                                    <p className={styles.cardDescription}>{t(benefit.description)}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Promise Section */}
                    <div className={styles.section} data-aos="fade-up">
                        <h3 className={styles.sectionHeading}>{t('TRUST.PROMISE.TITLE')}</h3>
                        <div className={styles.grid}>
                            {promises.map((promise, index) => (
                                <div key={index} className={styles.card} data-aos="fade-up" data-aos-delay={index * 100}>
                                    <div className={styles.iconWrapper}>
                                        <i className={promise.icon}></i>
                                    </div>
                                    <h4 className={styles.cardTitle}>{t(promise.title)}</h4>
                                    <p className={styles.cardDescription}>{t(promise.description)}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Process Section */}
                    <div className={styles.section} data-aos="fade-up">
                        <h3 className={styles.sectionHeading}>{t('TRUST.PROCESS.TITLE')}</h3>
                        <div className={styles.processGrid}>
                            {processSteps.map((step, index) => (
                                <div key={index} className={styles.processCard} data-aos="fade-up" data-aos-delay={index * 100}>
                                    <div className={styles.processNumber}>{index + 1}</div>
                                    <div className={styles.processIconWrapper}>
                                        <i className={step.icon}></i>
                                    </div>
                                    <h4 className={styles.processTitle}>{t(step.title)}</h4>
                                    <p className={styles.processDescription}>{t(step.description)}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
